import { render, staticRenderFns } from "./PopoverMenu.vue?vue&type=template&id=7a209038&"
import script from "./PopoverMenu.vue?vue&type=script&lang=js&"
export * from "./PopoverMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports